<template>
  <div>
    <HttpContentView :endpoint="utilities.path('modules/allowlist/players/@/status', playerId)" v-model:reload="reload">
      <template v-slot:content="{ data: entryData }">
        <div class="card mb-4">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between g-4">
              <div>
                <h3 v-if="entryData.entry" class="d-flex align-items-center g-3 mb-0">
                  <i class="fas fa-check-circle text-success" style="font-size: 1.2em"></i>
                  <span>{{ translate("allowlisted") }}</span>
                </h3>
                <h3 v-else class="d-flex align-items-center g-3 mb-0">
                  <i class="fas fa-xmark-circle text-warning" style="font-size: 1.2em"></i>
                  <span>{{ translate("allowlist.not.allowlisted") }}</span>
                </h3>
                <div v-if="entryData.entry" class="d-flex align-items-center g-4 mt-3">
                  <UserView :user="entryData.entry.creator"/>
                  <span class="text-muted">{{ utilities.formatDatetime(entryData.entry.createdAt) }}</span>
                </div>
              </div>
              <div class="d-flex align-items-center g-3">
                <ButtonView v-if="entryData.entry?.application" type="soft" color="primary" @click="viewApplicationId = entryData.entry.application.id">
                  <div class="d-flex align-items-center justify-content-center g-2">
                    <i class="fas fa-file-contract"></i>
                    <span>{{ translate("allowlist.application") }}</span>
                  </div>
                </ButtonView>
                <TargetedModalHttpFormView v-if="entryData.entry" size="small" :endpoint="utilities.path('modules/allowlist/entries/@', entryData.entry.id)" method="delete" @success="reload = true">
                  <template v-slot:target="{ show }">
                    <ButtonView type="soft" color="danger" @click="show">
                      <div class="d-flex align-items-center g-2">
                        <i class="fas fa-trash fa-fw"></i>
                        <span>{{ translate("allowlist.remove") }}</span>
                      </div>
                    </ButtonView>
                  </template>
                  <template v-slot:form="{ submit, loading, hide }">
                    <div class="d-flex align-items-center g-4">
                      <ButtonView type="soft" color="danger" class="w-100" @click="submit" :disabled="loading">
                        <div class="d-flex align-items-center g-2">
                          <i v-if="loading" class="fas fa-spinner fa-spin fa-fw"></i>
                          <i v-else class="fas fa-trash fa-fw"></i>
                          <span>{{ translate("allowlist.remove") }}</span>
                        </div>
                      </ButtonView>
                      <ButtonView type="normal" color="secondary" class="w-100" @click="hide">
                        {{ translate("cancel") }}
                      </ButtonView>
                    </div>
                  </template>
                </TargetedModalHttpFormView>
              </div>
            </div>
          </div>
        </div>
      </template>
    </HttpContentView>
    <CollectionView :endpoint="utilities.path('modules/allowlist/players/@/applications', playerId)" v-model:reload="reload">
      <template v-slot:header>
        <h4 class="mb-0">{{ translate("allowlist.applications") }}</h4>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("status") }}</div>
                <div class="table-header-cell">{{ translate("created_at") }}</div>
                <div class="table-header-cell">{{ translate("replied_at") }}</div>
                <div class="table-header-cell">{{ translate("actions") }}</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div class="table-column" :class="{ 'text-danger': item.status.id === 3, 'text-success': item.status.id === 2, 'text-info': item.status.id === 1 }">{{ item.status.name }}</div>
                  <div class="table-column">{{ utilities.formatDatetime(item.createdAt) }}</div>
                  <div class="table-column">{{ item.repliedAt ? utilities.formatDatetime(item.repliedAt) : "" }}</div>
                  <div class="table-column">
                    <div class="d-flex align-items-center g-2">
                      <ButtonView type="soft" color="primary" size="small" @click="viewApplicationId = item.id">
                        <i class="fas fa-eye"></i>
                      </ButtonView>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
    <ModalView :active="viewApplicationId !== undefined" @update:active="viewApplicationId = undefined" size="large">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between g-4">
          <h3 class="mb-0">{{ translate("allowlist.application") }}</h3>
          <ModalCloseButtonView @click="viewApplicationId = undefined"/>
        </div>
      </template>
      <template v-slot:body>
        <AllowlistApplicationView :application-id="viewApplicationId" @reply="viewApplicationId = undefined; reload = true" @delete="viewApplicationId = undefined; reload = true"/>
      </template>
    </ModalView>
  </div>
</template>

<script setup>
import {ButtonView, HttpContentView, utilities, CollectionView, ModalView, ModalCloseButtonView, TargetedModalHttpFormView} from "@/niftybit";
import UserView from "@/components/other/UserView.vue";
import {ref, watch} from "vue";
import AllowlistApplicationView from "@/systems/modules/allowlist/AllowlistApplicationView.vue";

const props = defineProps({
  playerId: String
});

const reload = ref(false);

const viewApplicationId = utilities.routeQueryParam("viewApplicationId");

watch(() => props.playerId, () => {
  reload.value = true
});

</script>